let ScofaFlagSelectedRows = [];

const SCOFA_TABLE_HEADER_KEY = {
    key: "scofa",
    title: "Scofa",
};

const HandleRowSelect = (data) => {
    const index = ScofaFlagSelectedRows.findIndex(item => item.id === data.id);
    if (data.value) {
        if (index === -1) {
            ScofaFlagSelectedRows.push(data);
        }
    } else {
        if (index !== -1) {
            ScofaFlagSelectedRows.splice(index, 1);
        }
    }
}

const ClearSelection = () => {
    ScofaFlagSelectedRows = [];
}

export { ScofaFlagSelectedRows, SCOFA_TABLE_HEADER_KEY, HandleRowSelect, ClearSelection };
